<div class="ir-item-line th-filter-modal">
  <div class="ir-item-cell s4 clickable" (click)="setOrderBy('name')">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      Name
    </span>
  </div>
  <div (click)="setOrderBy('Etag')" class="ir-item-cell s4 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      Last modified date
    </span>
  </div>
  <div class="ir-item-cell s2 clickable" *ngIf="node?.parent" (click)="gotoNodeParent(node)">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">subdirectory_arrow_left</i>
    </span>
  </div>
</div>
<div
  class="has-filter th-content-flow--dark ir-file-manager-droparea"
  dnd
  (filesChangeEmiter)="handleInputChange($event)"
  *ngIf="node?.children"
  [ngClass]="node?.children ? 'has-filter has-actions' : ''"
>
  <div *ngFor="let item of node.children" class="ir-item-line th-point clickable indent" (click)="openNode(item)">
    <!-- if folder -->
    <div class="ir-item-cell s4" *ngIf="!item.fileNode">
      <div class="ir-item-selector" (click)="selectNode($event, item)">
        <i class="material-icons" *ngIf="!item.selected">check_box_outline_blank</i>
        <i class="material-icons" *ngIf="item.selected">check_box</i>
      </div>
      <span class="icon-label"><i class="material-icons">folder</i> {{ item.name }}</span>
    </div>
    <!-- if file -->
    <div class="ir-item-cell s4" *ngIf="item.fileNode">
      <div class="ir-item-selector" (click)="selectNode($event, item)">
        <i class="material-icons" *ngIf="!item.selected">check_box_outline_blank</i>
        <i class="material-icons" *ngIf="item.selected">check_box</i>
      </div>
      <span class="icon-label"><i class="material-icons">insert_drive_file</i> {{ item.name }}</span>
    </div>
    <div class="ir-item-cell s4">
      <span>{{ item.date | formatDate }}</span>
    </div>
    <div class="ir-item-cell s2"></div>
  </div>
</div>
